var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 238,
    viewBox: "0 0 194 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 238,
    rx: 5.03896,
    fill: "#DFF0EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.0556 121.938C119.811 121.937 127.999 98.9927 130.143 80.1459C132.783 56.9277 121.881 39.4536 97.0556 39.4536C72.2347 39.4536 61.3263 56.9265 63.9686 80.1456C66.1145 98.9922 74.2993 121.94 97.0556 121.938Z",
    fill: "#94CEBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.611 176.57C158.362 169.257 157.511 161.91 156.243 154.711C154.708 145.989 152.753 133.203 145.192 127.519C140.819 124.233 135.156 123.154 130.149 121.173C127.713 120.209 125.53 119.251 123.481 118.161C116.567 125.797 107.551 129.791 97.0513 129.792C86.5548 129.792 77.5397 125.797 70.626 118.161C68.5774 119.251 66.3946 120.209 63.9581 121.173C58.9517 123.154 53.2889 124.232 48.9163 127.519C41.354 133.203 39.3999 145.989 37.8647 154.711C36.597 161.91 35.7457 169.257 35.4972 176.57C35.3047 182.235 38.0823 183.029 42.7883 184.739C48.6813 186.879 54.7653 188.468 60.89 189.77C72.7191 192.286 84.9122 194.219 97.0531 194.306C109.194 194.219 121.387 192.286 133.216 189.77C139.341 188.469 145.425 186.88 151.318 184.739C156.026 183.029 158.803 182.235 158.611 176.57Z",
    fill: "#94CEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvatar);
export default __webpack_public_path__ + "static/media/no-avatar.17f246a08cdaee4e9da91cc3de547e72.svg";
export { ForwardRef as ReactComponent };